import React, { useEffect, useState } from "react";
import { graphcms, QUERY_GALLERY } from "../Graphql/Queries";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Skeleton } from "@/components/ui/skeleton";

function Gallery() {
  const [galleries, setGalleries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    graphcms.request(QUERY_GALLERY).then((res) => {
      setGalleries(res.galleries);
      setLoading(false);
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>Gallery - IEEE CIS SBC UOJ</title>
        <link rel="canonical" href="https://cis.jfn.ac.lk/gallery" />
      </Helmet>
      <div className="mt-10 mb-20 container mx-auto">
        <h1 className="text-3xl font-bold text-center mb-10">Gallery</h1>
        <div className="grid gap-x-10 gap-y-16 grid-cols-fluid">
          {loading
            ? Array.from({ length: 8 }).map((_, index) => (
                <div
                  key={index}
                  className="card w-64 h-96 bg-slate-50 mx-auto rounded-xl drop-shadow-xl overflow-hidden">
                  <Skeleton className="w-64 h-64 rounded-t-xl" />
                  <div className="px-2 h-28 flex flex-col justify-center space-y-2">
                    <Skeleton className="h-4 w-3/4 mx-auto" />
                  </div>
                </div>
              ))
            : galleries?.map((gallery) => {
                return (
                  <Link to={`./${gallery.id}`} key={gallery.id}>
                    <div className="card w-64 h-96 bg-slate-50 mx-auto rounded-xl drop-shadow-xl overflow-hidden">
                      <img
                        className=" rounded-t-xl w-64 h-64 object-cover"
                        src={gallery.coverPicture.url}
                        alt={gallery.eventCategoryName}
                      />
                      <div className="px-2 h-28 flex flex-col justify-center">
                        <h4 className="w-full text-center text-base font-semibold">
                          {gallery.eventCategoryName}
                        </h4>
                      </div>
                    </div>
                  </Link>
                );
              })}
        </div>
      </div>
    </>
  );
}

export default Gallery;
